import { render, staticRenderFns } from "./best-progress-bar.component.vue?vue&type=template&id=0fb80416&scoped=true"
import script from "./best-progress-bar.component.vue?vue&type=script&lang=js"
export * from "./best-progress-bar.component.vue?vue&type=script&lang=js"
import style0 from "./best-progress-bar.component.vue?vue&type=style&index=0&id=0fb80416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb80416",
  null
  
)

export default component.exports